var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6145 12.4552L9.98251 8.1379C9.73848 8.01579 9.46728 7.95811 9.19468 7.97036C8.92209 7.98261 8.65715 8.06437 8.42506 8.20788C8.19297 8.35138 8.00144 8.55185 7.86867 8.79025C7.7359 9.02864 7.66631 9.29703 7.6665 9.5699V17.7246C7.66631 17.9974 7.7359 18.2658 7.86867 18.5042C8.00144 18.7426 8.19297 18.9431 8.42506 19.0866C8.65715 19.2301 8.92209 19.3118 9.19468 19.3241C9.46728 19.3363 9.73848 19.2787 9.98251 19.1566L18.6145 14.8392C18.8357 14.7284 19.0217 14.5582 19.1516 14.3477C19.2816 14.1371 19.3504 13.8946 19.3504 13.6472C19.3504 13.3998 19.2816 13.1573 19.1516 12.9468C19.0217 12.7363 18.8357 12.5661 18.6145 12.4552Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 25.647C19.6274 25.647 25 20.2744 25 13.647C25 7.01956 19.6274 1.64697 13 1.64697C6.37258 1.64697 1 7.01956 1 13.647C1 20.2744 6.37258 25.647 13 25.647Z",
    stroke: "black",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.463815fb9a73f2f4d07ab692a2644fcd.svg";
export { ForwardRef as ReactComponent };